(() => {
  const firstKey = 'eb_first_touch';
  const lastKey = 'eb_last_touch';
  const pendingKey = 'eb_pending_lead_event';
  const params = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'wbraid', 'gbraid', 'fbclid'];
  const query = new URLSearchParams(window.location.search);

  const read = (key) => {
    try { return JSON.parse(window.localStorage.getItem(key) || 'null'); } catch (_) { return null; }
  };
  const write = (key, value) => {
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
  };
  const hasCampaign = params.some((key) => query.get(key));
  const touch = {
    landing_page: window.location.href,
    referrer: document.referrer || '',
    captured_at: new Date().toISOString(),
  };
  params.forEach((key) => { touch[key] = query.get(key) || ''; });
  if (!read(firstKey)) write(firstKey, touch);
  if (hasCampaign || !read(lastKey)) write(lastKey, touch);

  const push = (event, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    const payload = { event, ...detail };
    window.dataLayer.push(payload);
    if (typeof window.gtag === 'function') window.gtag('event', event, detail);
    document.dispatchEvent(new CustomEvent(`eb:${event}`, { detail: payload }));
  };
  const addHidden = (form, name, value) => {
    let field = form.querySelector(`[name="${name}"]`);
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    field.value = value || '';
  };
  const eventForSource = (source) => {
    const value = (source || '').toLowerCase();
    if (value.includes('sample')) return 'sample_request';
    if (value.includes('trade')) return 'trade_application';
    if (value.includes('catalog')) return 'catalog_request';
    if (value.includes('custom')) return 'custom_inquiry';
    return 'quote_submit';
  };
  const enrich = (form) => {
    const sourceField = form.querySelector('[name="contact[Source page]"]');
    if (!sourceField) return null;
    const first = read(firstKey) || touch;
    const last = read(lastKey) || touch;
    const fields = {
      'contact[First touch UTM source]': first.utm_source,
      'contact[First touch UTM medium]': first.utm_medium,
      'contact[First touch UTM campaign]': first.utm_campaign,
      'contact[Last touch UTM source]': last.utm_source,
      'contact[Last touch UTM medium]': last.utm_medium,
      'contact[Last touch UTM campaign]': last.utm_campaign,
      'contact[Landing page]': first.landing_page,
      'contact[Latest page]': window.location.href,
      'contact[Initial referrer]': first.referrer,
      'contact[gclid]': last.gclid || first.gclid,
      'contact[wbraid]': last.wbraid || first.wbraid,
      'contact[gbraid]': last.gbraid || first.gbraid,
    };
    Object.entries(fields).forEach(([name, value]) => addHidden(form, name, value));
    return sourceField.value;
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('form').forEach((form) => {
      const source = enrich(form);
      if (!source) return;
      form.addEventListener('submit', () => {
        const specificEvent = eventForSource(source);
        const detail = { lead_type: source, page_location: window.location.href };
        push('generate_lead', detail);
        push(specificEvent, detail);
        try { window.sessionStorage.setItem(pendingKey, specificEvent); } catch (_) {}
      });
    });
    document.querySelectorAll('a[href*="wa.me/"]').forEach((link) => {
      link.addEventListener('click', () => push('whatsapp_click', { link_url: link.href, page_location: window.location.href }));
    });
    const posted = new URLSearchParams(window.location.search).get('contact_posted') === 'true';
    if (posted) {
      let event = '';
      try { event = window.sessionStorage.getItem(pendingKey) || ''; window.sessionStorage.removeItem(pendingKey); } catch (_) {}
      push('lead_confirmed', { lead_type: event || 'contact', page_location: window.location.href });
    }
  });
})();
